export const SEARCH_SUGGESTION_MAX = 20;
